<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.errorSmsList.push"
    :is-show-search-input="false"
  >
    <v-column-time/>
    <el-table-column label="手机号" prop="phone" width="140px"/>
    <el-table-column label="错误码" prop="code" width="180px"/>
    <el-table-column label="错误消息" prop="message">
      <template slot-scope="{ row }">
        <div class="overflow-box">{{ row.message }}</div>
      </template>
    </el-table-column>
    <el-table-column label="请求 ID" prop="request_id" width="240px"/>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`error-sms-list-${k}-${v.add_time}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone }}</span>
            </div>
            <div class="list-item-detail">
              <span>错误码</span>
              <span>{{ v.code }}</span>
            </div>
            <div class="list-item-detail">
              <span class="flex-shrink">错误消息</span>
              <span class="list-item-info">{{ `${v.message}${v.message && v.message.length > 31 ? '……' : ''}` }}</span>
            </div>
            <div class="list-item-detail">
              <span class="flex-shrink">请求 ID</span>
              <span class="list-item-info">{{ v.request_id }}</span>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { getSmsList } from '@/api/error-log';

export default {
  name: RouteConfig.errorSmsList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await getSmsList(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
<style src="./index.css" scoped/>
